import { AppState } from "../appState";

// Base selector to access filter date master state
export const dateMasterSelector = (state: AppState) => state.overagesFilterDateData;

